/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useCallback, useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {defaultValues} from '../../../data/constants/demanderRDV';
import {StackParams} from '../../../data/types/navigation';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../components/Header/HeaderScreen';
import {Loader} from '../../components/Loader';
import ConfirmationModal from '../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../components/PageContainer';
import {Form} from './Form';

type NavigationProps = StackNavigationProp<
  StackParams,
  'SouscriptionAssuranceRCVPForm'
>;

const dataws = {
  ...defaultValues,
};

export const FDemandeRdv = (props: any) => {
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const [listAgence, setListAgence] = useState([]);
  const [dataDto, setDataDto] = useState(dataws);
  const [postSucces, setPostSuccess] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const {getAgence, addRendezvous, user} = props;
  const [messageErreur, setMessageErreur] = useState('');
  const [showConfirmaation, setShowConfirmation] = useState(false);
  const [btnName, setBtnName] = useState('');
  const checkSaisieMsg = 'Vérifier votre saisie';

  const updateData = (user: any) => {
    dataDto.mail = user.email;
    dataDto.nomPrenom = `${user.nom} ${user.prenom}`;
    dataDto.telephone = user.telephone;

    return dataDto;
  };

  const mapAgence = useCallback((list: any) => {
    list = list.map((e: any) => {
      return {
        value: e.nom,
        label: e.nom,
      };
    });
    return list;
  }, []);

  useEffect(() => {
    if (user && user.data && user.data.utilisateur) {
      const _data = updateData(user.data.utilisateur);
      setDataDto({...dataDto, ..._data});
    } else {
      setDataDto({...dataDto, nomPrenom: '', telephone: '', mail: ''});
    }
  }, [user]);

  useEffect(() => {
    setIsLoading(true);
    getAgence({}, (res: any) => {
      if (res && !res.isError && res.data && res.data.items) {
        const _list = mapAgence(res.data.items);
        setListAgence(_list);
      }
      setIsLoading(false);
    });
  }, []);

  const handleCancel = () => {
    goBack();
  };

  const proccessSave = () => {
    setShowConfirmation(() => false);
    setIsLoading(true);

    addRendezvous(dataDto, (res: any) => {
      if (res && !res.isError && res.data) {
        setMessageErreur('Votre demande de rendez-vous a bien été envoyée');
        setBtnName("Retourner à l'accueil");
        setPostSuccess(true);
      } else {
        setMessageErreur(checkSaisieMsg);
        setBtnName('Quitter');
      }
      setIsLoading(false);
      setShowConfirmation(false);
      setPostSuccess(true);
    });
  };

  const handleSubmit = (dataws: any) => {
    setDataDto(dataws);
    setShowConfirmation(true);
  };

  const verificationRdv = () => {
    setPostSuccess(false);
  };
  const goToHome = () => {
    setPostSuccess(false);
    navigate('Home');
  };
  return (
    <View>
      <HeaderScreen title="Nous contacter" type="home" noBreadcrumb={false} />
      <PageContainer>
        {/** Confirmation modal */}
        {showConfirmaation && (
          <ConfirmationModal
            title="Nous contacter"
            content="Voulez-vous confirmer votre envoi?"
            btn1="Confirmer"
            btn2="Annuler"
            handleBtn1={proccessSave}
            handleBtn2={() => {
              setShowConfirmation(false);
            }}
          />
        )}
        {postSucces && (
          <ConfirmationModal
            title="Nous contacter"
            content={messageErreur}
            btn1={btnName}
            handleBtn1={() => {
              messageErreur === checkSaisieMsg ? verificationRdv() : goToHome();
            }}
          />
        )}
        {/** Loading */}
        {IsLoading && <Loader />}
        {/** Form content */}
        {!postSucces && !IsLoading && (
          <Form
            data={dataDto}
            listAgence={listAgence}
            onCancelForm={handleCancel}
            onSubmitForm={handleSubmit}
          />
        )}
      </PageContainer>
    </View>
  );
};
export const DemandeRdv: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FDemandeRdv);
